import React, { FC } from 'react';
import { ContentResourceLoader } from 'ia-react-core';
import transformContest from './transformContest';
import getContestApiRoot from '../../../utils/getContestApiRoot';
import { ContestDto } from '../../../interfaces/dtos/ContestDto';
import { ResourceInfo } from '../../Resource/Resource/Resource';
import ContestParticipationResource from './ContestParticipationResource';
import SubscribeResource from '../SubscribeResource';
import UnsubscribeResource from '../UnsubscribeResource';
import SubscriptionEntriesResource from '../SubscriptionEntriesResource';
import ReminderResource from '../ReminderResource';

export const ContestResourceInfo: ResourceInfo = {
  name: '/App.contest.contestResource',
  dataDst: '/App.contest.info',
};

export interface ContestResourceProps { }

const ContestResource: FC<ContestResourceProps> = () => (
  <ContentResourceLoader
    autoRequest
    requestOnLanguageChange
    CustomDataErrorMessage={() => null}
    {...ContestResourceInfo}
    url={`${getContestApiRoot()}/latest`}
    transformResponse={({ data }: { data: ContestDto }) => transformContest(data)}
  >
    <ContestParticipationResource />
    <SubscribeResource />
    <UnsubscribeResource />
    <SubscriptionEntriesResource />
    <ReminderResource />
  </ContentResourceLoader>
);

export default ContestResource;
